<template>
  <transition name="zoom">
    <div class="ecr-picker modal" v-if="show">
      <div class="modal-backdrop" @click="closeModal"/>

      <div class="modal-dialog">
        <div class="modal-header">
          <slot name="header"/>
          <div type="button" class="modal-close" @click="closeModal"><i class="fas fa-times"></i></div>
        </div>

        <div class="modal-body">
          <slot name="body"/>
        </div>

        <div class="modal-footer">
          <slot name="footer"/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, defineExpose, defineProps } from 'vue';

const show = ref(false);

//watch(props.show, toggleModal);
const props = defineProps(["onClose", "onOpen"]);
defineExpose({openModal, closeModal});

function openModal() {
  show.value = true;
  document.querySelector("body").classList.remove("overflow-hidden");
  props.onOpen();
}

function closeModal() {
  show.value = false;
  document.querySelector("body").classList.add("overflow-hidden");
  props.onClose();
}
</script >

<style scoped>
.modal {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
}
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.modal-dialog {
  background-color: #ffffff;
  position: relative;
  width: 65%;
  margin: 50px auto;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  z-index: 2;
  @media screen and (max-width: 992px) {
    width: 90%;
  }
}
.modal-close {
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.modal-header {
  padding: 20px 20px 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 1.2em;
  font-weight: bold;
}


.modal-body {
  padding: 0 20px;
  margin-bottom: 10px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.modal-footer {
  padding: 10px 20px 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>